module.exports = __webpack_public_path__ + "assets/images/4ca0ee4b4c7a52eb0ba54e1623aee671.png";